import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdateKanbanTicket } from '../services/patchUpdateKanbanTicket.service';

// arg: { projectId, ticketId, changes: { stage, stageTimestamps }, previous }
// `previous` is not sent to the API — the slice uses it to roll back the
// optimistic update when the request fails.
export const moveKanbanTicket = createAsyncThunk(
  'kanban/moveKanbanTicket',
  async ({ projectId, ticketId, changes }) => {
    const updatedTicket = await patchUpdateKanbanTicket(
      projectId,
      ticketId,
      changes
    );
    return updatedTicket;
  }
);
